import React from "react";
import { chosenTheme } from "../../theme";

export default function WIDTimeSeries() {
  const theme = chosenTheme;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="800.867"
      height="554.305"
      viewBox="0 0 800.867 554.305"
      role="img"
      artist="Katerina Limpitsouni"
      source="https://undraw.co/"
    >
      <g transform="translate(-333 -245)">
        <path
          d="M0,699.454c0,.646.323,1.164.725,1.164H158.456c.4,0,.725-.518.725-1.164s-.323-1.164-.725-1.164H.725C.323,698.29,0,698.808,0,699.454Z"
          transform="translate(974.686 98.687)"
          fill="#f2f2f2"
        />
        <g transform="translate(996.206 500.02)">
          <path
            d="M210.786,447.448l-16.776-.46,7.767-21.6,13.616,4.891Z"
            transform="translate(-162.028 -395.378)"
            fill="#ed9da0"
          />
          <ellipse
            cx="15.895"
            cy="15.895"
            rx="15.895"
            ry="15.895"
            transform="translate(28.93 5.811)"
            fill="#ed9da0"
          />
          <g transform="translate(23.356 269.754)">
            <rect
              width="12.452"
              height="17.666"
              transform="translate(24.268 0)"
              fill="#ed9da0"
            />
            <path
              d="M210.333,698.453c2.132.2,12.785,1.037,13.313-1.409a10.326,10.326,0,0,0-.333-4.9c-1.027-10.193-1.409-10.3-1.634-10.369-.362-.108-1.418.391-3.14,1.506l-.108.068-.02.127c-.029.156-.792,3.9-4.4,3.326-2.475-.391-3.277-.939-3.531-1.2a1.526,1.526,0,0,0,.655-.548,1.933,1.933,0,0,0,.137-1.594,25.7,25.7,0,0,0-1.917-4.3l-.157-.284-14.154,9.547-8.735,2.494a2.231,2.231,0,0,0-1.457,1.291h0a2.258,2.258,0,0,0,.567,2.543c1.585,1.428,4.744,3.864,8.05,4.177.88.078,2.044.117,3.355.117,5.468,0,13.44-.567,13.5-.577Z"
              transform="translate(-184.677 -670.663)"
              fill="#2f2e43"
            />
          </g>
          <g transform="translate(77.591 264.895)">
            <rect
              width="12.452"
              height="17.666"
              transform="matrix(0.981, -0.196, 0.196, 0.981, 19.465, 2.442)"
              fill="#ed9da0"
            />
            <path
              d="M155.588,695.167c2.123-.225,12.736-1.5,12.785-3.991a10.362,10.362,0,0,0-1.291-4.744c-3-9.792-3.394-9.831-3.639-9.85-.381-.029-1.321.665-2.788,2.093l-.088.088v.127c0,.166-.01,3.981-3.658,4.128-2.5.1-3.394-.274-3.7-.489a1.578,1.578,0,0,0,.538-.665,1.9,1.9,0,0,0-.176-1.594,26.172,26.172,0,0,0-2.719-3.844l-.205-.245-12,12.139-8.08,4.167a2.246,2.246,0,0,0-1.174,1.555h0a2.265,2.265,0,0,0,1.056,2.387c1.839,1.086,5.409,2.866,8.716,2.514.88-.1,2.025-.293,3.306-.548,5.36-1.076,13.068-3.189,13.127-3.208Z"
              transform="translate(-129.349 -665.746)"
              fill="#2f2e43"
            />
          </g>
          <path
            d="M131.84,524.8l58.383-6.319,26.866,147.1L198.4,667.946l-31.527-96.879,1.56,99.647H148.191Z"
            transform="translate(-102.91 -397.409)"
            fill="#2f2e43"
          />
          <path
            d="M156.5,438.39l30.463-3.6,30.1,103.6s-15.232-3.159-24.525,7.121-41.283-1.4-41.283-1.4L156.5,438.38Z"
            transform="translate(-123.709 -396.13)"
            fill="#dfdfe0"
          />
          <path
            d="M234.53,549.534c-.88,4.343.734,8.315,3.609,8.862s5.918-2.524,6.8-6.877a10.655,10.655,0,0,0-.176-5.233l3.492-18.458-9.029-1.428-2.485,18.351a10.763,10.763,0,0,0-2.2,4.783h0Z"
            transform="translate(-234.29 -397.582)"
            fill="#ed9da0"
          />
          <path
            d="M246.834,437.22l-12.442,1.223A15.408,15.408,0,0,0,222.5,450.425l-18.1,88.007h12.237L246.843,437.21Z"
            transform="translate(-203.641 -395.636)"
            fill="#dfdfe0"
          />
          <path
            d="M211.184,426.315l-1.565-.714c.655-2.954,1.252-6.28-.411-8.8-.919-1.389-2.485-2.485-2.68-4.138-.166-1.369.7-2.768.323-4.1-.4-1.4-1.966-2.044-3.345-2.514a23.069,23.069,0,0,0-6.632-1.516,7.7,7.7,0,0,0-6.133,2.436,10.826,10.826,0,0,0-1.125,1.771c-1.144,2.074-3.12,6.084-3.12,6.084s.078-.919.068-2.749a19.43,19.43,0,0,1-1.536-4.852,9.132,9.132,0,0,1,1.839-5.742,15.318,15.318,0,0,1,11.689-6.72c4.656-.215,8.921.108,11.278,4.128a16.267,16.267,0,0,0,1.36,2.24c1.027,1.252,2.582,1.917,3.844,2.925a12.847,12.847,0,0,1,4.588,9.987c-.2,3.6-1.516,7.023-2.827,10.378-1.125,2.9-3.443,5.84-6.378,6.857.313-1.555.616-3.111.929-4.666"
            transform="translate(-157.466 -394.709)"
            fill="#2f2e43"
          />
          <g transform="translate(39.418 38.66)">
            <path
              d="M145.037,439.043l.186.254,5.654,7.728,6.524,8.931,1.467,2.005,5.38,7.366a52.712,52.712,0,0,0,4.558,4.607l.059.049c1.017.919,2.172,1.9,3.443,2.876,7.19,5.536,18.008,10.946,27.4,3.678,11.924-9.234-14.233-29.815-27.546-39.205a16.929,16.929,0,0,0-15.035-2.26l-12.09,3.971Z"
              transform="translate(-140.892 -434.231)"
              fill="#dfdfe0"
            />
            <path
              d="M182.469,450.013a10.687,10.687,0,0,0,3.991,1.6c.323.059.646.108.978.137l6.769,5,1.79,1.321,6.339,4.685,5.272-7.473-9.733-6.427-5.947-3.932a10.735,10.735,0,0,0-3.639-3.766,10.552,10.552,0,0,0-5.566-1.771h-.01a2.186,2.186,0,0,0-.362.02,4.494,4.494,0,0,0-3.727,1.839C177.01,443.694,178.742,447.616,182.469,450.013Z"
              transform="translate(-178.02 -434.343)"
              fill="#ed9da0"
            />
            <path
              d="M165.32,459.461l4.969-10.721,22.019,8.217-10.594,16.218Z"
              transform="translate(-150.297 -434.547)"
              fill="#dfdfe0"
            />
          </g>
        </g>
        <g transform="translate(333 245)">
          <path
            d="M481.208,223.907c1.912-3.849,4.967-7.044,6.836-10.914s2.232-9.049-.881-12.011c-2.644-2.515-6.785-2.55-9.946-4.372-8.055-4.641-8.045-19.381-17.253-20.655-4.478-.619-8.529,2.739-11.236,6.359s-4.863,7.845-8.616,10.364c-4.249,2.852-9.742,2.975-14.46,4.956-9.046,3.8-13.789,13.562-17.754,22.536-2.555,5.781-5.168,12.016-3.982,18.224-2.576,1.6-1.428,5.915,1.144,7.525s5.8,1.575,8.754,2.272c6.207,1.466,11.289,6.407,13.7,12.312,1.878,4.6,2.262,9.655,2.624,14.613l1.886,25.806c.28,3.827.647,7.894,2.976,10.943s7.374,4.327,9.992,1.522c2.5-2.681,1.375-6.924,1.325-10.591s3.264-8.233,6.389-6.315l1.1-2.5a39.453,39.453,0,0,0,26.022-33.925C480.626,247.884,475.782,234.832,481.208,223.907Z"
            transform="translate(-254.166 -146.369)"
            fill="#e6e6e6"
          />
          <path
            d="M490.1,303.7a4.968,4.968,0,0,0-2.85-8.552l.012.413a8.543,8.543,0,0,1-4.432,1.165,13.421,13.421,0,0,0-4.56.722,3.843,3.843,0,0,0-2.529,3.536,3.732,3.732,0,0,0,2.012,2.8,11.026,11.026,0,0,0,3.422,1.039C484.244,305.4,487.832,305.839,490.1,303.7Z"
            transform="translate(-255.765 -148.971)"
            fill="#e6e6e6"
          />
          <path
            d="M551.3,224.986a11.288,11.288,0,0,0,3.2-3.316,3.85,3.85,0,0,0-.25-4.343,5.158,5.158,0,0,0-3.49-1.261,27.151,27.151,0,0,0-10.286,1.213l10.224,9.058Z"
            transform="translate(-257.177 -147.244)"
            fill="#e6e6e6"
          />
          <path
            d="M534.014,232.929c1.377,1.52.938,3.879.548,5.893s-.44,4.531,1.293,5.63c1.5.952,3.609.175,4.707-1.223a10.837,10.837,0,0,0,1.741-4.981,34.807,34.807,0,0,0,.727-7.862,12.121,12.121,0,0,0-2.67-7.3,8.593,8.593,0,0,0-9.74-2.276l1.583-.078a15.456,15.456,0,0,0-2.576,4.943,5.25,5.25,0,0,0,1.3,5.169C531.869,231.665,533.178,232.007,534.014,232.929Z"
            transform="translate(-256.936 -147.335)"
            fill="#e6e6e6"
          />
          <path
            d="M613.476,207.127l.281-.867a5.935,5.935,0,0,0-2.67,6.978A6.485,6.485,0,0,0,613.476,207.127Z"
            transform="translate(-258.712 -147.032)"
            fill="#e6e6e6"
          />
          <path
            d="M597.828,219.534a11.028,11.028,0,0,0,5.511-8.249,6.066,6.066,0,0,0-.357-3.15,3.256,3.256,0,0,0-2.371-1.958l-.641,1.009c-.92-.791-2.464.022-2.851,1.172a6.279,6.279,0,0,0,.3,3.571,4.705,4.705,0,0,1-.056,3.542,12.736,12.736,0,0,1-1.735,1.823,1.817,1.817,0,0,0-.331,2.284C595.9,220.268,597.028,219.979,597.828,219.534Z"
            transform="translate(-258.368 -147.03)"
            fill="#e6e6e6"
          />
          <path
            d="M591.142,213.986a6,6,0,0,0,.747-3.238l-1.4-.44a5.989,5.989,0,0,0-2.317,1.676,1.825,1.825,0,1,0,2.972,2Z"
            transform="translate(-258.207 -147.12)"
            fill="#e6e6e6"
          />
          <path
            d="M661.286,206.814c.127.106.253.215.38.323.112-.023.218-.066.332-.08Z"
            transform="translate(-259.814 -147.044)"
            fill="#e6e6e6"
          />
          <path
            d="M658.943,219.127,662.805,216a6.44,6.44,0,0,0,1.716-1.8,4.363,4.363,0,0,0-.311-4.2,11.555,11.555,0,0,0-2.64-2.854,4.774,4.774,0,0,0-3.644,5.188c.233,1.477,1.16,3.056.4,4.345-.295.5-.8.844-1.141,1.316s-.45,1.225.017,1.573C657.723,219.951,658.441,219.534,658.943,219.127Z"
            transform="translate(-259.718 -147.051)"
            fill="#e6e6e6"
          />
          <path
            d="M661.831,225.78a3.343,3.343,0,0,0,2.585-1.018,22.828,22.828,0,0,0,4.469-4.91L660.2,222.6l.9,1.056C660.3,224.184,660.89,225.6,661.831,225.78Z"
            transform="translate(-259.79 -147.328)"
            fill="#e6e6e6"
          />
          <path
            d="M670.165,231.852a2.22,2.22,0,0,0,2.293,1.4,3.316,3.316,0,0,0,2.364-1.513,4.4,4.4,0,0,0-3.462-6.871l.8,1.222C672.363,228.175,669.528,229.855,670.165,231.852Z"
            transform="translate(-260.005 -147.438)"
            fill="#e6e6e6"
          />
          <path
            d="M727.648,255.2a4.517,4.517,0,0,0,5.421-.013,4.835,4.835,0,0,0,.289-7.085l-1.479.826a3.767,3.767,0,0,0-5.13,1.019,4.107,4.107,0,0,0,.9,5.253Z"
            transform="translate(-261.229 -147.945)"
            fill="#e6e6e6"
          />
          <path
            d="M745.157,257.247a4.383,4.383,0,0,0,3.006-3.054l-2.876-.378a6.368,6.368,0,0,0-2.718-1.187,2.183,2.183,0,0,0-2.368,1.4,2.363,2.363,0,0,0,.806,2.16,4.382,4.382,0,0,0,4.15,1.064Z"
            transform="translate(-261.535 -148.043)"
            fill="#e6e6e6"
          />
          <path
            d="M733.126,263.2a2.479,2.479,0,0,0,1.657,2.077,2.686,2.686,0,0,0,2.982-.462,1.646,1.646,0,0,0-.6-2.611l-2.157-.392C734.177,261.377,733.112,262.258,733.126,263.2Z"
            transform="translate(-261.381 -148.241)"
            fill="#e6e6e6"
          />
          <path
            d="M605.145,278.7l-1.669-1.524A5.465,5.465,0,0,0,605.145,278.7Z"
            transform="translate(-258.552 -148.579)"
            fill="#e6e6e6"
          />
          <path
            d="M592.142,268.983c1.028,4.773,6.168,8.661,10.835,7.227l.246.225c-1.486-2.034-1.738-5.043-1.391-7.659a26.972,26.972,0,0,1,15.559-20.73,6.42,6.42,0,0,0,2.92-1.9c.665-.973.417-2.641-.729-2.915a2.729,2.729,0,0,0-1.779.412l-8.673,4.269c-4.38,2.156-8.848,4.374-12.289,7.838S591.114,264.21,592.142,268.983Z"
            transform="translate(-258.299 -147.838)"
            fill="#e6e6e6"
          />
          <path
            d="M447.661,436.97a106.491,106.491,0,0,0-26.294-13.741c-5.755-2.046-11.938-3.607-17.935-2.445a21.348,21.348,0,0,0-15.1,12.056,22.358,22.358,0,0,0,.731,19.379c2.765,5.182,7.553,9.308,9.154,14.959,1.079,3.81.568,7.866.048,11.791l-3.185,24.064c-.966,7.3-1.908,14.9.4,21.9s8.91,13.16,16.24,12.417l1.452-.109c-4.848-3.3-6.207-10.122-4.764-15.8s5.107-10.5,8.685-15.147l31.848-41.355c4.3-5.577,8.838-12.471,6.548-19.127C454.188,442.023,450.914,439.3,447.661,436.97Z"
            transform="translate(-253.817 -151.704)"
            fill="#e6e6e6"
          />
          <path
            d="M372.355,398.9c-1.075-.364-2.211.445-2.843,1.388a19.056,19.056,0,0,1-1.794,2.883c-1.654,1.7-4.667,1.366-6.451-.2s-2.556-3.994-2.9-6.343c-.415-2.819-.236-5.964,1.625-8.123,1.915-2.222,5.064-2.818,7.961-3.28,2.992-.477,6.345-.874,8.8.907,1.544,1.122,2.444,2.932,3.875,4.2s3.975,1.742,5.052.166a3.879,3.879,0,0,0-.052-3.593,8.794,8.794,0,0,1-1.068-3.557c.072-1.732,1.463-3.109,2.887-4.1s3.031-1.845,3.965-3.306c1.149-1.8,1.027-4.112,1.739-6.122,1.725-4.866,7.88-7.03,9.673-11.871a4.577,4.577,0,0,0,.137-3.21c-.75-1.928-2.779-1.55-2.9-3.906-.119-2.254,1.761-4.465,3.672-5.407,2.634-1.3,5.706-1.193,8.641-1.272s6.1-.469,8.253-2.465a7.114,7.114,0,0,0-.756-10.582c-1.605-1.109-3.635-1.494-5.2-2.663-1.946-1.456-2.867-3.881-4.382-5.781a22.234,22.234,0,0,0-4.292-3.8l-3.9-2.895c-2.351-1.744-4.8-3.533-7.657-4.154s-6.267.258-7.7,2.811a8.684,8.684,0,0,0-.9,3.655,52.634,52.634,0,0,0,.373,8.954l.708,7.169c.212,2.142-.016,4.966-2.1,5.522-4.613,1.233-3.057-5.588-4.08-7.677-1.566-3.2-8.762-4.735-11.838-6.068-1.921-.833-3.949-1.752-5.109-3.495-1.444-2.169-1.147-5.122-.015-7.469a31.466,31.466,0,0,1,4.653-6.253c1.708-2.034,3.264-4.191,4.818-6.346l5.406-7.5c2.311-3.2,4.741-7.116,3.428-10.843a2.917,2.917,0,0,0-5.338.644c-.575,2.012.96,4.581-.509,6.072a2.753,2.753,0,0,1-3.532-.066,8.024,8.024,0,0,1-2.111-3.193c-1.779-3.953-3.512-7.931-5.338-11.863-.577-1.243-1.18-3.371-2.929-3.162-1.519.182-2.339,2.4-2.286,3.68.077,1.87,1.11,3.54,1.9,5.236s1.342,3.733.475,5.391c-1.1,2.1-3.879,2.571-6.247,2.5a29.291,29.291,0,0,1-12.787-3.374l-.31,6.582-9.43-3.947-1.831-.767c-2.651-1.11-5.306-2.221-8.036-3.122-1.55-.511-3.121-.954-4.691-1.4l-2.864-.807a15.027,15.027,0,0,0-5.878-.839c-2.1.263-3.966,1.389-5.905,2.231-4.326,1.878-9.921-.011-14.557-.045a19.462,19.462,0,0,0-32.7.906,38.946,38.946,0,0,0-2.173,4.37l-1.887,4.229c-.923,2.068-1.866,4.246-1.684,6.5s1.912,4.563,4.176,4.542c-5.339,2.417-6.45,10.876-1.916,14.59,1.255,1.028,2.795,1.7,3.925,2.866a6.154,6.154,0,0,1-4.624,10.435,14.989,14.989,0,0,0,17.817-5.581c1.938-3.035,2.781-6.826,5.418-9.279,3.492-3.248,9.26-3,13.288-.442s6.576,6.9,8.328,11.338c2.3,5.813,3.767,12.454,8.66,16.342,2.366,1.88,5.362,2.937,7.453,5.119,2.978,3.107,3.493,7.8,3.426,12.1s-.531,8.767,1.037,12.775,6.061,7.3,10.091,5.793a16.05,16.05,0,0,0,6.719,18.747l-2.2-13.66c3.659,1.03,6.03,4.579,7.4,8.125s2.093,7.381,4.079,10.622c3.126,5.1,8.787,7.3,14.546,7.285,6.221-.021,8.583-2.987,12.683-7.355a6.69,6.69,0,0,0,1.819-2.731A2.3,2.3,0,0,0,372.355,398.9Z"
            transform="translate(-250.858 -148.481)"
            fill="#e6e6e6"
          />
          <path
            d="M392.841,401.447l-10.432-1.64,5.469,3.288a19.777,19.777,0,0,0,4.911,2.366,6.671,6.671,0,0,0,5.284-.556l-.445-.851C396.926,402.281,394.724,401.743,392.841,401.447Z"
            transform="translate(-253.729 -151.255)"
            fill="#e6e6e6"
          />
          <path
            d="M390.331,421.029l.024-.06a2.041,2.041,0,0,0-2.073-.961,7.581,7.581,0,0,1-2.425.039,3.441,3.441,0,0,1-2.085-2.37c-.346-1.04-.448-2.152-.842-3.175a4.66,4.66,0,0,0-3.766-3.072,3.255,3.255,0,0,0-3.5,2.938,5.436,5.436,0,0,0,.812,2.469L377.6,419a14.545,14.545,0,0,0,1.088,1.862,7.27,7.27,0,0,0,11.643.166Z"
            transform="translate(-253.581 -151.508)"
            fill="#e6e6e6"
          />
          <path
            d="M369.713,231.117c2.648,1.561,5.964,2.637,7.222,5.441l.726.234-2.375,2.951c-.978,1.216-2.007,2.57-1.984,4.131.032,2.149,2.1,3.77,4.187,4.277A9.176,9.176,0,0,0,388.1,241.9c.248-.906.351-1.845.569-2.759a22.441,22.441,0,0,1,2.842-6.107L412.6,197.546c.876-1.473,1.778-3.235,1.12-4.818a3.785,3.785,0,0,0-3.737-2.005,11.1,11.1,0,0,0-4.254,1.431,7.245,7.245,0,0,0-5.667-3.633,21.393,21.393,0,0,0-6.955.606,42.819,42.819,0,0,0-14.591,5.013c-2.473,1.25-5.194,2.794-5.912,5.47-.883,3.292,1.962,6.647,5.236,7.594s6.77.152,10.084-.645a7.63,7.63,0,0,1-12.754,7.2c-2.376-2.313-3.539-6.329-6.8-6.926s-5.835,2.873-6.553,6.1a17.331,17.331,0,0,0,7.9,18.186Z"
            transform="translate(-253.272 -146.643)"
            fill="#e6e6e6"
          />
          <path
            d="M410.772,289.652a62.355,62.355,0,0,0-6.134-12.588,37.613,37.613,0,0,0-6.973-8.4,26.941,26.941,0,0,0-8.433-4.94c-3-1.084-6.336-1.62-9.367-.631s-5.61,3.807-5.548,6.994c.068,3.525,3.152,6.281,6.366,7.729s6.789,2.079,9.821,3.876a14.721,14.721,0,0,1,7.07,11.884l.764,1.263a15.264,15.264,0,0,0-4.764,2.594,5.181,5.181,0,0,0-1.809,4.869c.53,2.134,2.709,3.359,4.68,4.335l10.923,5.41c-1.854-5.528,4.216-10.673,4.552-16.494a15.247,15.247,0,0,0-1.146-5.9Z"
            transform="translate(-253.552 -148.26)"
            fill="#e6e6e6"
          />
          <path
            d="M317.944,274.627c2.209,1.715,5.6.913,7.628-1.017s3.009-4.678,3.928-7.319a28.259,28.259,0,0,0,.094,7.868,9.531,9.531,0,0,0,4.147,6.446,11.175,11.175,0,0,0,3.192,1.162,26.869,26.869,0,0,0,15.589-1.114l.045-1.7c-2.5.285-4.387-2.454-4.552-4.962s.745-4.968.825-7.48-1.131-5.448-3.6-5.895a4.782,4.782,0,0,1-6.081,6.561c-2.863-1.164-3.9-4.652-6.116-6.81a9.28,9.28,0,0,0-10.183-1.432,12.629,12.629,0,0,0-6.546,8.324C315.638,269.839,315.837,272.991,317.944,274.627Z"
            transform="translate(-252.279 -148.161)"
            fill="#e6e6e6"
          />
          <path
            d="M387.137,256.479l.1-.166a5.276,5.276,0,0,0-4.394-3.09,28.552,28.552,0,0,0-5.637.186,8.174,8.174,0,0,1-5.406-1.191c-1.284-.96-2.016-2.47-3.042-3.7s-2.688-2.244-4.18-1.656c-1.615.638-2.045,2.9-1.262,4.45a7.867,7.867,0,0,0,3.957,3.23,30.521,30.521,0,0,0,19.861,1.939Z"
            transform="translate(-253.304 -147.914)"
            fill="#e6e6e6"
          />
          <path
            d="M365.963,262.143a2.48,2.48,0,0,0,2.763,4.114l.545.538c.724-1.3,1.023-3.035.1-4.2a2.573,2.573,0,0,0-3.4-.454Z"
            transform="translate(-253.348 -148.241)"
            fill="#e6e6e6"
          />
          <path
            d="M359.38,266.862a2.3,2.3,0,0,0-1.432-2.167,2.2,2.2,0,0,0-2.552,1.889,4.386,4.386,0,0,0,1.149,3.3,3.026,3.026,0,0,0,2.1,1.32c.854.028,1.724-.865,1.378-1.646l-1.3-.025a6.731,6.731,0,0,0,.66-2.672Z"
            transform="translate(-253.139 -148.306)"
            fill="#e6e6e6"
          />
          <path
            d="M333.36,253.078l1.436,1.164a17.22,17.22,0,0,0,2.675,1.9,7.328,7.328,0,0,0,5.451.667,5.611,5.611,0,0,0,3.836-3.786c.572-2.157-.361-4.4-1.275-6.432a3.9,3.9,0,0,0-1-1.531,1.338,1.338,0,0,0-1.693-.067,1.675,1.675,0,0,0-.273,1.609,4.386,4.386,0,0,1,.264,1.677c-.091.563-.682,1.1-1.2.862l-.083,1.916c-2.486-1.258-3.8-4.6-6.566-4.935a3.414,3.414,0,0,0-3.409,5.01,6.858,6.858,0,0,0,1.842,1.946Z"
            transform="translate(-252.609 -147.871)"
            fill="#e6e6e6"
          />
          <path
            d="M327.248,244.685a3.785,3.785,0,0,0,1.614-3.606,2.327,2.327,0,0,0-3.159-1.686,3.747,3.747,0,0,0-1.408,2.161l-1.965,5.544,1.1-.8a11.136,11.136,0,0,0,3.818-1.611Z"
            transform="translate(-252.418 -147.751)"
            fill="#e6e6e6"
          />
          <path
            d="M340.32,233.139a2.166,2.166,0,0,0-.669-3.253l-1.377-.129a2.066,2.066,0,1,0,2.046,3.381Z"
            transform="translate(-252.732 -147.545)"
            fill="#e6e6e6"
          />
          <path
            d="M353.25,235.149c1.285.615,2.911,1.2,4.028.318a2.54,2.54,0,0,0,.778-2.421,6.157,6.157,0,0,0-1.136-2.393,22.988,22.988,0,0,0-6.393-6.173l-.621.807c-.868,2.253-1.705,4.883-.5,6.971A8.227,8.227,0,0,0,353.25,235.149Z"
            transform="translate(-252.995 -147.429)"
            fill="#e6e6e6"
          />
          <path
            d="M363.132,237.435l2.4,1.087a2.253,2.253,0,0,0-2.4-1.087Z"
            transform="translate(-253.308 -147.711)"
            fill="#e6e6e6"
          />
          <path
            d="M356.476,245.163l-1.135.374c-.965,1.586-.546,3.614-.1,5.416.284,1.139.9,2.54,2.069,2.489,1.141-.05,1.646-1.434,1.865-2.555a7.712,7.712,0,0,0,.108-3.736A2.647,2.647,0,0,0,356.476,245.163Z"
            transform="translate(-253.125 -147.88)"
            fill="#e6e6e6"
          />
          <path
            d="M338,239.673l.84.338a.9.9,0,1,0-.84-.338Z"
            transform="translate(-252.755 -147.729)"
            fill="#e6e6e6"
          />
          <path
            d="M381.241,305.321a2.553,2.553,0,0,0-2.336,3.441c.825,1.776,3.665,1.784,4.928.287a3.865,3.865,0,0,0-1-5.6Z"
            transform="translate(-253.649 -149.152)"
            fill="#e6e6e6"
          />
          <path
            d="M423.08,348.372a2.556,2.556,0,0,0-1.792,3.2l2.358.164,2.4-1.2a2.556,2.556,0,0,0-2.962-2.158Z"
            transform="translate(-254.575 -150.132)"
            fill="#e6e6e6"
          />
          <path
            d="M413.277,351.327a4.874,4.874,0,0,0-2.043,4.266,3.9,3.9,0,0,0,3.051,3.447,3.259,3.259,0,0,0,3.683-2.5c.4-2.439-2.223-4.226-3.165-6.511Z"
            transform="translate(-254.357 -150.169)"
            fill="#e6e6e6"
          />
          <path
            d="M506.9,334.645c.249,1.831-1.4,3.435-1.462,5.282-.073,2.191,2.313,3.9,4.495,3.681a7.107,7.107,0,0,0,5.106-3.75l.047-.205-3.189-3.6c-1.305-1.475-2.689-3.155-2.638-5.124.025-.971.408-1.911.386-2.882a6.984,6.984,0,0,0-.462-2.037c-.288-.859-.68-1.827-1.538-2.117-1.074-.363-2.158.589-2.671,1.6a6.331,6.331,0,0,0,.187,5.962C505.783,332.506,506.736,333.433,506.9,334.645Z"
            transform="translate(-256.389 -149.597)"
            fill="#e6e6e6"
          />
          <path
            d="M496.7,341.343a1.831,1.831,0,0,0,1.527.1,7.99,7.99,0,0,0,2.687-.976,2.714,2.714,0,0,0,1.314-2.4,3.139,3.139,0,0,0-2.557-2.374,2.749,2.749,0,0,0-2.558.391c-.792.743-.7,2-.542,3.079l-.167.28C496.259,340.1,496.163,340.929,496.7,341.343Z"
            transform="translate(-256.213 -149.853)"
            fill="#e6e6e6"
          />
          <path
            d="M667.719,421.438l-.69-1.715C666.714,420.5,666.831,421.293,667.719,421.438Z"
            transform="translate(-259.935 -151.689)"
            fill="#e6e6e6"
          />
          <path
            d="M802.27,297.249c-2.95-3.2-4.757-5.046-6.62-9.013a14.605,14.605,0,0,0-11.051-8.3c-6.12-1.008-12.374.588-18.569.268-9.922-.512-18.869-5.834-28.371-8.737a118.71,118.71,0,0,0-16.214-3.344l-9.466-1.5c-10.343-1.636-20.751-3.276-31.22-3.059-3.019.063-7.224-.845-6.982-3.854.3-3.738,7.026-3.247,8.319-6.767.8-2.177-1.115-4.464-3.216-5.448s-4.525-1.281-6.432-2.6-2.951-4.386-1.2-5.907l-14.569,7.469c-4.038,2.07-8.549,4.763-9.262,9.244a10.711,10.711,0,0,0-6.014,4.178c-2.732.014-4.878,2.637-5.329,5.331s.368,5.421,1.178,8.03c-.991-1.9-2.043-3.868-3.79-5.107s-4.405-1.474-5.894.064c-1.528,1.579-1.171,4.228-.09,6.14s2.741,3.457,3.761,5.4c3.185,6.078-2.587,14.635-9.415,13.958q.687-9.414,1.374-18.828a12.6,12.6,0,0,0-.474-5.759c-.745-1.8-2.652-3.272-4.55-2.848-3.413.763-3.121,5.762-1.7,8.958s2.835,7.64-.063,9.6c-1.872,1.264-4.409.483-6.429-.526s-4.182-2.252-6.391-1.781-3.6,3.847-1.646,4.984l-9.708-1.687a6.905,6.905,0,0,1-8.641,5.513l-.953-3.95-1.421-.4c1.486.414-.839,6.683-2.924,11.471-2.8-.329-6.9-.392-7.366-1.2-2.238-3.846-1.972-13.007-5.861-15.171q-2.925-1.628-6-2.966a14.072,14.072,0,0,0-3.385-1.111c-2.388-.376-4.8.364-7.1,1.1a18.214,18.214,0,0,0-12.654,9.332L522.582,308.2a21.178,21.178,0,0,0-3.093,5.8,7.573,7.573,0,0,0,.7,6.273,4.855,4.855,0,0,0,5.686,1.943c1.29-.558,2.582-1.824,3.861-1.24.968.443,1.21,1.715,1.109,2.775a7.414,7.414,0,0,0-.057,3.162c.582,1.65,2.821,2.224,4.418,1.51a6.829,6.829,0,0,0,3.246-3.952c1.539-3.947,1.382-8.314,1.765-12.533s1.536-8.731,4.863-11.354c1-.785,2.458-1.351,3.483-.6a2.49,2.49,0,0,1,.612,2.827,11.074,11.074,0,0,1-1.66,2.607,14.294,14.294,0,0,0-2.351,11.157l.68.421c2.594-.673,6.065.532,9.508,1.687A12.375,12.375,0,0,0,549.068,323c-3.98,5.584-6.861,10.869-14.734,10.8-1.868-.016-3.72-.385-5.587-.389a7.3,7.3,0,0,0-5.182,1.726c-1.416,1.387-1.854,3.5-3.065,5.066-1.593,2.062-4.255,2.9-6.687,3.838-1.777.685-3.65,1.608-4.467,3.328a8.245,8.245,0,0,0-.342,4.408c.274,2.605.758,5.568,2.969,6.975a7.031,7.031,0,0,0,5.411.458c2.3-.559,4.547-1.612,6.908-1.455a7.732,7.732,0,0,1,6.8,7.52c.019,1.88-.53,4.037.717,5.445a3.329,3.329,0,0,0,4.707-.2,5.425,5.425,0,0,0,1.022-4.979,16.016,16.016,0,0,0-2.345-4.725,5.514,5.514,0,0,1,6.346,2.934c.823,1.829.557,3.94.82,5.929s1.474,4.2,3.476,4.314a2.806,2.806,0,0,0,2.822-2.215,20.163,20.163,0,0,0-.165-3.02,3.868,3.868,0,0,1,3.907-3.6,5.513,5.513,0,0,0,1.351,6.884c1.524,1.179,3.539,1.443,5.437,1.773s3.924.851,5.149,2.338c2.041,2.477-.456,3.593-.845,5.691-.477,2.576,1.674,6.38,2.5,8.844l11.393,15.938a19.283,19.283,0,0,0,2.978,3.53,10.473,10.473,0,0,0,13.524-.488,11.6,11.6,0,0,0,1.969-13.635c-2.222-4.044-6.624-6.549-8.8-10.619a23.206,23.206,0,0,0,12.739,5.239,64.233,64.233,0,0,1,23.144,9.706A32.273,32.273,0,0,0,630.9,420.17a28.524,28.524,0,0,1,8.276-16.436c2.926-2.853,6.923-5.154,10.937-4.386s7.059,5.886,4.631,9.173l6.1.454,2.737,6.8a2.356,2.356,0,0,1,2.3-1.6c1.9.288,3.24,2.059,5.052,2.714,3.415,1.233,7.065-2.183,7.507-5.787s-1.273-7.083-2.938-10.309a19.241,19.241,0,0,0,19.772-29.195,49,49,0,0,1,13.764-10.134c4.763-2.353,9.972-3.968,14.134-7.268s7.081-9.032,5.079-13.952c-1.414-3.476-4.962-5.835-6.023-9.434-1.537-5.21,3.132-10.6,8.406-11.9s10.781.3,15.977,1.886c-.8-5.346,5.4-10.357,10.459-8.459l6.359-2.575c-2.457,5.417-7.781,8.863-11.7,13.341s-6.246,11.771-2.157,16.09l17.585-15.938,18.393-16.671-.878-2.58C790.474,301.808,796.721,299.986,802.27,297.249Z"
            transform="translate(-256.487 -147.746)"
            fill="#e6e6e6"
          />
          <path
            d="M497.564,371.392a2.018,2.018,0,0,0,.012,2.32,1.776,1.776,0,0,0,2.263.03,5.179,5.179,0,0,0,1.434-1.984,3.229,3.229,0,0,0,3.283,1.72,8.075,8.075,0,0,0,3.622-1.511,7.942,7.942,0,0,0,2.2-1.908,3.141,3.141,0,0,0,.553-2.766,4.765,4.765,0,0,0-1.429-1.845l-4.653-4.3-.526-.158a2.964,2.964,0,0,0-4.276-.046c-.963,1.078-.967,2.689-.82,4.127s.376,2.97-.264,4.267C498.595,370.083,497.973,370.672,497.564,371.392Z"
            transform="translate(-256.233 -150.388)"
            fill="#e6e6e6"
          />
          <path
            d="M587.294,420.655a32.342,32.342,0,0,1-24.577-24.7c-.572-2.848-.831-5.959-2.725-8.16-1.834-2.131-4.83-2.9-7.642-2.9s-5.583.647-8.39.822c-4.906.306-10.105-.99-13.614-4.433-1.661-1.631-2.919-3.7-4.86-4.987-2.608-1.728-6.065-1.727-9.037-.748-3.31,1.091-5.959,4.076-9.578,3.665-3.764-.427-8.126-1.758-9.6,3.2-.425,1.427-.28,2.992-.818,4.38-.829,2.14-3.031,3.346-4.772,4.84-3.507,3.011-5.372,7.584-6,12.163s-.142,9.23.344,13.826c.262,2.479.607,5.147,2.31,6.968,2.374,2.538,6.357,2.44,9.821,2.154l12.072-1c2.169-.179,4.641-.255,6.185,1.279.925.919,1.317,2.249,2.131,3.268a5.017,5.017,0,0,0,6.121,1.234,10.162,10.162,0,0,0,7.666,15.056l.31.2c-2.576,4.411-5.249,9.365-4.181,14.361.916,4.283,4.463,7.717,5.044,12.059.532,3.983-1.546,8.057-.627,11.969.931,3.962,4.932,6.724,8.991,7.019s8.047-1.506,11.191-4.09a48.256,48.256,0,0,0,7.971-9.2c1.479-2.031,3-4.146,3.5-6.607.54-2.619-.086-5.521,1.187-7.872,1.469-2.712,4.955-3.728,6.714-6.26,2.279-3.279.936-7.745,1.44-11.707C575.121,436.643,587.577,430.533,587.294,420.655Z"
            transform="translate(-255.975 -150.711)"
            fill="#e6e6e6"
          />
          <path
            d="M587.569,455.877c-.341,1.531-1.774,2.538-3.14,3.309s-2.868,1.548-3.564,2.953c-.713,1.439-.387,3.155-.014,4.717q1.163,4.875,2.741,9.638a98.157,98.157,0,0,0,5.327-11.921,15.663,15.663,0,0,0,1.169-4.78,5.91,5.91,0,0,0-1.607-4.517Z"
            transform="translate(-258.05 -152.465)"
            fill="#e6e6e6"
          />
          <path
            d="M673.192,438.26l-5.135-5.927c-1.17-1.351-2.505-2.794-4.279-3.02l-.73.466,4.452,10.6a10.065,10.065,0,0,0,2.688,4.228c1.328,1.044,3.482,1.244,4.59-.031a3.4,3.4,0,0,0,.4-3.377,10.03,10.03,0,0,0-1.989-2.94Z"
            transform="translate(-259.852 -151.899)"
            fill="#e6e6e6"
          />
          <path
            d="M690.225,442.055a4.92,4.92,0,0,0,2.909-2.712,14.583,14.583,0,0,0,1.041-3.949l.877-5.308-.383-.1a1.7,1.7,0,0,0-2.161.6,8.464,8.464,0,0,0-.968,2.261,2.74,2.74,0,0,1-1.564,1.8c-1.374.415-2.675-1.041-4.109-.985a2.583,2.583,0,0,0-2.244,2.3,5.008,5.008,0,0,0,.939,3.29C685.785,441.154,688.055,442.68,690.225,442.055Z"
            transform="translate(-260.301 -151.91)"
            fill="#e6e6e6"
          />
          <path
            d="M700.041,445.525l3.944-10.388a10.132,10.132,0,0,0-3.944,10.388Z"
            transform="translate(-260.654 -152.026)"
            fill="#e6e6e6"
          />
          <path
            d="M720.594,437.2l-.8.034a5.146,5.146,0,0,0-.043,4.556,10.268,10.268,0,0,0,2.976,3.617,20.9,20.9,0,0,0,6.564,3.665,41.773,41.773,0,0,0,10.786,1.661l6.264.41c.995.065,2.281-.061,2.558-1.019.228-.791-.445-1.534-1.074-2.065a39.361,39.361,0,0,0-19.358-8.786C725.762,438.857,722.89,438.688,720.594,437.2Z"
            transform="translate(-261.078 -152.071)"
            fill="#e6e6e6"
          />
          <path
            d="M742.213,465.183l-4.505-4.369c-1.46-1.416-3.648-2.917-5.322-1.761-.962.665-1.259,1.961-2.074,2.8a4.005,4.005,0,0,1-3.714.884,11.818,11.818,0,0,1-3.586-1.7l-3.726-2.312-3.857-2.394-2.9,2.82c.126-1.388-1.724-2.289-3.005-1.741a4.643,4.643,0,0,0-2.311,3.3,18.069,18.069,0,0,1-1.109,4.017c-1.473,2.821-5.051,3.656-8.2,4.129s-6.712,1.138-8.4,3.838c-1.4,2.249-.983,5.136-.514,7.745l1.774,9.87a5.4,5.4,0,0,0,1.363,3.222c1.558,1.375,3.972.539,5.873-.3a39.718,39.718,0,0,1,12.623-3.658,18.216,18.216,0,0,1,12.506,3.2c2.255,1.717,3.975,4.095,6.365,5.62a12.625,12.625,0,0,0,11.043.964,16.442,16.442,0,0,0,8.4-7.49,19.674,19.674,0,0,0-.424-19.476A38.621,38.621,0,0,0,742.213,465.183Z"
            transform="translate(-260.408 -152.488)"
            fill="#e6e6e6"
          />
          <path
            d="M738.87,506.474a2.653,2.653,0,0,0-.168,3.145,4.346,4.346,0,0,0,2.776,1.787,12.9,12.9,0,0,0,3.376.155l.034-.842a8.65,8.65,0,0,0-1.977-3.984C741.823,505.7,739.9,505.382,738.87,506.474Z"
            transform="translate(-261.493 -153.568)"
            fill="#e6e6e6"
          />
          <path
            d="M778.293,507.4l-.538-.2L773.911,513c-.69,1.039-1.409,2.287-.988,3.461.5,1.389,2.338,1.8,3.768,1.429a5.944,5.944,0,0,0,4.3-4.718,5.836,5.836,0,0,0-2.7-5.77Z"
            transform="translate(-262.247 -153.598)"
            fill="#e6e6e6"
          />
          <path
            d="M788.317,501.081l-3.538-2.812q-.071,1.957-.142,3.914l-.133,0a25.99,25.99,0,0,1,2.306,2.293c.828.7,2.217,1.026,2.925.2a1.85,1.85,0,0,0,.076-2.042,5.431,5.431,0,0,0-1.5-1.556Z"
            transform="translate(-262.502 -153.403)"
            fill="#e6e6e6"
          />
          <path
            d="M722.9,375.843c-1.484-.046-3.127-.137-4.278.8a5.736,5.736,0,0,0-.987,1.151l-.406.568a15.608,15.608,0,0,0-1.58,2.541,3.353,3.353,0,0,0-.215,2.772,1.607,1.607,0,0,0,2.372.681c.634-.588.486-1.654.966-2.373a2.217,2.217,0,0,1,1.786-.854,11.745,11.745,0,0,1,2.04.231,9.84,9.84,0,0,0,9.63-15.043l-.119-.365a4.4,4.4,0,0,0-4.458,3.437c-.332,1.73.372,3.739-.677,5.154C726.087,375.738,724.381,375.89,722.9,375.843Z"
            transform="translate(-260.99 -150.516)"
            fill="#e6e6e6"
          />
          <path
            d="M736.542,357.319l-.226-.02a11.475,11.475,0,0,0-3.764,1.4,1.744,1.744,0,0,0-.858.87,1.266,1.266,0,0,0,.3,1.164,3.733,3.733,0,0,0,1,.751,5.939,5.939,0,0,0,1.814.811,2.014,2.014,0,0,0,1.852-.478,2.676,2.676,0,0,0,.434-2.217,11.66,11.66,0,0,0-.55-2.284Z"
            transform="translate(-261.349 -150.327)"
            fill="#e6e6e6"
          />
          <path
            d="M713.192,376.419a5.718,5.718,0,0,0,.745-1.851l.415-1.527-1.48-.9a8.566,8.566,0,0,0-1.937,1.381,2.89,2.89,0,0,0-.889,2.14,1.767,1.767,0,0,0,1.453,1.649,1.941,1.941,0,0,0,1.693-.892Z"
            transform="translate(-260.877 -150.651)"
            fill="#e6e6e6"
          />
          <path
            d="M548.468,235.848c-.585.365-.42,1.246-.182,1.894l.818,2.23.381-1.443a3.066,3.066,0,0,0,.422-1.861C549.774,236.034,549.018,235.505,548.468,235.848Z"
            transform="translate(-257.343 -147.675)"
            fill="#e6e6e6"
          />
          <path
            d="M920.12,367.758H672.64a22.524,22.524,0,0,1-22.5-22.5V168.209a22.524,22.524,0,0,1,22.5-22.5H920.12a22.524,22.524,0,0,1,22.5,22.5V345.259a22.523,22.523,0,0,1-22.5,22.5Z"
            transform="translate(-259.57 -145.711)"
            fill="#fff"
          />
          <path
            d="M920.12,367.758H672.64a22.524,22.524,0,0,1-22.5-22.5V168.209a22.524,22.524,0,0,1,22.5-22.5H920.12a22.524,22.524,0,0,1,22.5,22.5V345.259a22.523,22.523,0,0,1-22.5,22.5ZM672.64,147.667A20.565,20.565,0,0,0,652.1,168.209V345.259A20.565,20.565,0,0,0,672.64,365.8H920.12a20.565,20.565,0,0,0,20.542-20.542V168.209a20.565,20.565,0,0,0-20.542-20.542Z"
            transform="translate(-259.57 -145.711)"
            fill="#3f3d56"
          />
          <path
            d="M741.016,173.1H701.889a3.913,3.913,0,0,1,0-7.825h39.127a3.913,3.913,0,0,1,0,7.825Z"
            transform="translate(-260.614 -146.137)"
            fill="#ccc"
          />
          <path
            d="M826.118,263.1H701.889a3.913,3.913,0,0,1,0-7.825H826.118a3.913,3.913,0,0,1,0,7.825Z"
            transform="translate(-260.614 -148.101)"
            fill="#ccc"
          />
          <circle
            cx="26.234"
            cy="26.234"
            r="26.234"
            transform="translate(437.046 37.825)"
            fill={theme.imageHighlight}
          />
          <rect
            width="5.869"
            height="1.956"
            transform="translate(437.362 189.715)"
            fill="#3f3d56"
          />
          <path
            d="M876.576,341.614H864.267v-1.956h12.309Zm-24.618,0H839.649v-1.956h12.309Zm-24.618,0H815.031v-1.956H827.34Zm-24.617,0H790.414v-1.956h12.309Zm-24.618,0H765.8v-1.956H778.1Zm-24.618,0H741.178v-1.956h12.309Zm-24.618,0H716.56v-1.956h12.309Z"
            transform="translate(-261.02 -149.943)"
            fill="#3f3d56"
          />
          <rect
            width="5.869"
            height="1.956"
            transform="translate(627.865 189.715)"
            fill="#3f3d56"
          />
          <rect
            width="4.891"
            height="33.258"
            transform="translate(532.088 155.099)"
            fill={theme.imageHighlight}
          />
          <rect
            width="4.891"
            height="33.258"
            transform="translate(581.976 155.099)"
            fill={theme.imageHighlight}
          />
          <rect
            width="4.891"
            height="14.673"
            transform="translate(606.43 173.685)"
            fill={theme.imageHighlight}
          />
          <rect
            width="4.891"
            height="47.931"
            transform="translate(556.543 140.426)"
            fill={theme.imageHighlight}
          />
          <circle
            cx="5.869"
            cy="5.869"
            r="5.869"
            transform="translate(82.125 209.877)"
            fill={theme.imageHighlight}
          />
          <circle
            cx="5.869"
            cy="5.869"
            r="5.869"
            transform="translate(97.776 181.51)"
            fill={theme.imageHighlight}
          />
          <circle
            cx="5.869"
            cy="5.869"
            r="5.869"
            transform="translate(269.936 159.012)"
            fill={theme.imageHighlight}
          />
        </g>
      </g>
    </svg>
  );
}
